import { t } from '!/i18n'
import {
  extendMediaItemByLabelPrice,
  getLabelPriceForPurchasedItem,
} from '@/tools'
import {
  type FormattedPriceSettings,
  type VodBundleWithContent,
} from '@setplex/tria-api'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type {
  UiVodBundleWithContent,
  VodWithPrice,
} from '~/shared/interfaces/vod'

export const getLowestPriceFromPriceSettings = (
  priceSettings: FormattedPriceSettings[] | null
): FormattedPriceSettings | null => {
  if (!priceSettings) return null

  return priceSettings.reduce((prev, min) =>
    Number(prev.price) < Number(min.price) ? prev : min
  )
}

// VodWithPrice
export const formatVodBundleWithContentToUi = (
  bundle: VodBundleWithContent | null,
  adjustVod: AdjustPurchaseableFn,
  adjustSet: AdjustPurchaseableFn
): UiVodBundleWithContent | null => {
  if (!bundle) return null
  const adjustedBundle = adjustSet(bundle)
  const { priceSettings, purchaseInfo, vods } = adjustedBundle
  const lowestPrice = getLowestPriceFromPriceSettings(priceSettings ?? null)

  const price = lowestPrice?.price
  const currency = lowestPrice?.currency

  const rentedDuration = getLabelPriceForPurchasedItem({ purchaseInfo })
  const labelRented = rentedDuration
    ? t('rented_to', {
        duration: rentedDuration,
      })
    : ''

  const vodsFormatted = adjustedBundle.purchaseInfo
    ? vods
    : vods.map(
        (vod) =>
          extendMediaItemByLabelPrice(adjustVod(vod), true) as VodWithPrice
      )

  return {
    ...adjustedBundle,
    vods: vodsFormatted,
    labelRented,
    priceText: t('watch_all_for', {
      price,
      currency,
    }),
  }
}
